import request, { REQUEST_METHODS } from '@api/Request';
import { ArchiveEndpoints } from './config';
import { ArchiveRequestItem, ArchiveRequestResponse, UnArchiveRequestResponse } from './types';

export default class ArchiveService {
  // Mutations -------------------------------------------------------------------------------------

  public static readonly archiveRequest = (requests: ArchiveRequestItem[]): Promise<ArchiveRequestResponse> =>
    request({
      url: ArchiveEndpoints.archiveRequest(),
      method: REQUEST_METHODS.POST,
      data: requests,
    });

  public static readonly unArchiveRequest = (requests: ArchiveRequestItem[]): Promise<UnArchiveRequestResponse> =>
    request({
      url: ArchiveEndpoints.unArchiveRequest(),
      method: REQUEST_METHODS.POST,
      data: requests,
    });
}
